module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h12",
    attrs: {
      "id": "d7e117013"
    }
  }, [_vm._v("Checklist for Life ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e117513"
    }
  }, [_c('i', [_vm._v("Courage is almost a contradiction in terms. It means a ")]), _c('i', [_vm._v("strong desire to live taking the form of a readiness to die.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e118313"
    }
  }, [_c('i', [_vm._v("—G. K. Chesterton ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d9t00813"
    }
  }, [_c('i', [_vm._v("Let nothing be done through selfish ambition or conceit, ")]), _c('i', [_vm._v("but in lowliness of mind let each esteem others better than ")]), _c('i', [_vm._v("himself.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e120113"
    }
  }, [_c('i', [_vm._v("—Philippians 2:3 ")]), _c('i', [_vm._v("NKJV ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ffb13a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c10_r1.vue
// module id = 78
// module chunks = 0